<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    :title="title || defauleTitle"
    show-close
    top="5vh"
    :width="width"
    :close-on-click-modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
    :modal-append-to-body="false"
    :modal="false"
  >
    <Main
      ref="main"
      :multiple="multiple"
      :reserve="reserve"
      :highlight="highlight"
      :tableHeight="tableHeight"
      :url="url"
      :method="method"
      :extraData="extraData"
      @choose-change="(e) => (checkedRow = e)"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-badge :value="checkedCount" class="ml-2" v-if="multiple">
        <el-button
          type="primary"
          size="small"
          @click="confirm()"
          :disabled="!checkedCount"
        >
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </el-badge>
      <el-button
        v-if="!multiple"
        type="primary"
        size="small"
        class="ml-2"
        @click="confirm()"
        :disabled="!checkedCount"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    width: { type: String, default: '90%' },
    confirmOnClose: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    reserve: { type: Boolean, default: false },
    highlight: { type: Boolean, default: true },
    tableHeight: { type: Number, default: 500 },
    url: { type: String, default: '/factory/fty/material/batch/ftylist' },
    method: { type: String, default: 'POST' },
    extraData: { type: Object, default: () => {} },
  },
  data() {
    return {
      checkedRow: null,
      defauleTitle:
        this.$l('INDEX.dialog_title_choose_material_batch') || '选择物料批次',
    }
  },
  computed: {
    checkedCount() {
      if (this.multiple) {
        return !this.checkedRow ? 0 : this.checkedRow.length
      }
      return this.checkedRow ? 1 : 0
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      this.checkedRow = null
    },
    confirm() {
      if (!this.checkedCount) return
      this.$emit('confirm', this.checkedRow)
      if (this.confirmOnClose) this.close()
      this.checkedRow = null
    },
  },
}
</script>
